/*
  Handles the app wide number text formatting

  eg. followersCount: 1,234
*/
function getNumberFormat(num) {
  num = Number(num);
  if (isNaN(num)) return 0;

  return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export default getNumberFormat;
